module.exports = __webpack_public_path__ + "img/mencelinsta.0988b480.jpg";